<template>
  <section class="c_result">
    <h2 class="c_result_ttl">事前登録/クイズ/テスト/アンケート</h2>
    <div class="c_result_list">
      <div class="c_tool_item">
        <figure class="c_tool_item_img">
          <img
            src="https://placehold.jp/cfcfcf/4a4a4a/90x90.png?text=事前登録"
            alt
            width="90"
            height="90"
          />
        </figure>
        <div class="c_tool_item_cnt">
          <p class="c_tool_item_ttl">
            <em>事前登録</em>
          </p>
        </div>
        <div class="c_tool_item_link">
          <router-link class="c_tool_item_link" to="/survey">
            回答する
          </router-link>
        </div>
      </div>
      <!-- 事後アンケート -->
      <div class="c_tool_item" v-for="(survey, i) in surveys" :key="i">
        <figure class="c_tool_item_img">
          <img :src="survey.image" alt width="90" height="90" />
        </figure>
        <div class="c_tool_item_cnt">
          <p class="c_tool_item_ttl">
            <em>{{ survey.title }}</em>
          </p>
        </div>
        <div class="c_tool_item_link">
          <router-link
            v-if="survey.title === '確認クイズ' && survey.url === ''"
            class="c_tool_item_link"
            to="/quiz"
          >
            チャレンジする
          </router-link>
          <a
            v-else-if="survey.title === '確認クイズ'"
            class="c_tool_item_link"
            :href="survey.url"
            target="_blank"
          >
            チャレンジする
          </a>
          <a v-else class="c_tool_item_link" :href="survey.url" target="_blank">
            回答する
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    surveys: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
.c_result_list {
  margin-top: 20px;
}
</style>
